module.exports = __webpack_public_path__ + "static/media/phone-cmf.40e2d5fc.svg";